/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import iconLayers from './icons/layers.png';
import iconPomiar from './icons/pomiar.png';
import iconKlucz from './icons/klucz.png';
import Popover from 'react-bootstrap/lib/Popover';
import MenuIcon from './MenuIcon';
import s from './MapNav.scss';
import { connect } from 'react-redux';

class MapNav extends React.Component {
  state = {
    intl: this.props.intl,
  }
  componentWillReceiveProps(nextProps){
    if (JSON.stringify(nextProps.intl) !== JSON.stringify(this.state.intl)) {
      this.setState({
        intl: nextProps.intl,
      });
    }
  }
  toggleFullScreen() {
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    let TextToSpeech = this.props.currentPopup === 'TextToSpeech' ? "activeList" : null;
    let user_login = this.props.currentPopup === 'user_login' ? "activeList" : null;
    let info = this.props.currentPopup === 'info' ? "activeList" : null;
    let MeasureTools = this.props.currentPopup === 'MeasureTools' ? "activeList" : null;
    let SpatialAnalysis = this.props.currentPopup === 'SpatialAnalysis' ? "activeList" : null;
    let searchboxCss = this.props.currentPopup === 'searchbox' ? "activeList" : null;
    let zooming = this.props.currentPopup === 'zooming' ? "activeList" : null;
    let blocking = this.props.currentPopup === 'blocking' ? "activeList" : null;

    const popover0 = <Popover key={this.state.intl.langKeys.szukajDzialke} id="popover-trigger-hover" >{this.state.intl.langKeys.szukajDzialke}</Popover>
    const popover1 = <Popover key={this.state.intl.langKeys.maxmin} id="popover-trigger-hover" >{this.state.intl.langKeys.maxmin}</Popover>
    const popover2 = <Popover key={this.state.intl.langKeys.poprzCel} id="popover-trigger-hover" >{this.state.intl.langKeys.poprzCel}</Popover>
    const popover3 = <Popover key={this.state.intl.langKeys.nastCel} id="popover-trigger-hover" >{this.state.intl.langKeys.nastCel}</Popover>
    const popover4 = <Popover key={this.state.intl.langKeys.wykPom} id="popover-trigger-hover" >{this.state.intl.langKeys.wykPom}</Popover>
    const popover5 = <Popover key={this.state.intl.langKeys.wydruk} id="popover-trigger-hover" >{this.state.intl.langKeys.wydruk}</Popover>
    const popover6 = <Popover key={this.state.intl.langKeys.syntezatorMow} id="popover-trigger-hover" >{this.state.intl.langKeys.syntezatorMow}</Popover>
    const popover7 = <Popover key={this.state.intl.langKeys.narzedzia} id="popover-trigger-hover" >{this.state.intl.langKeys.narzedzia}</Popover>
    const popover9 = <Popover key={this.state.intl.langKeys.kontoUzyt} id="popover-trigger-hover" >{this.state.intl.langKeys.kontoUzyt}</Popover>
    const popover10 = <Popover key={this.state.intl.langKeys.infoOgolne} id="popover-trigger-hover" >{this.state.intl.langKeys.infoOgolne}</Popover>
    const popover11 = <Popover key={this.state.intl.langKeys.zmianaJezyka} id="popover-trigger-hover" >{this.state.intl.langKeys.zmianaJezyka}</Popover>
    const popover12 = <Popover key={this.state.intl.langKeys.powiekszOknem} id="popover-trigger-hover" >{this.state.intl.langKeys.powiekszOknem}</Popover>
    const popover13 = <Popover key={this.state.intl.langKeys.zdefiniujObsz} id="popover-trigger-hover" >{this.state.intl.langKeys.zdefiniujObsz}</Popover>
    const popover14 = <Popover key={this.state.intl.langKeys.wyszOfert} id="popover-trigger-hover" >{this.state.intl.langKeys.wyszOfert}</Popover>
    const popover15 = <Popover key={this.state.intl.langKeys.wydrukPDF} id="popover-trigger-hover" >{this.state.intl.langKeys.wydrukPDF}</Popover>

    return (
      <div className={
        [
          'gmina_siekierczyn',
          'gmina_strzegom',
          'gmina_swierzawa',
          'gmina_zarow',
          'jawor',
          'swiebodzice'
        ].includes(this.props.prefix)
        ? 'mapNavContainer2'
        : 'mapNavContainer'
      }>
        
        <ul className={'mapNav-list'} style={{ marginRight: '10px' }} >
          {[
            'gmina_siekierczyn',
            'gmina_strzegom',
            'gmina_swierzawa',
            'gmina_zarow',
            'jawor',
            'swiebodzice'
          ].includes(this.props.prefix)
          ? null
          : <span>
              <MenuIcon
                overlay={popover0}
                textPlacement="bottom"
                actionOnClick={this.props.toggleSearchbox}
                iconStyling="glyphicon glyphicon-search"
                liClass={"in-on-mobile " + searchboxCss}
              />
              <MenuIcon
                overlay={popover12}
                textPlacement="bottom"
                actionOnClick={this.props.zoomingRectangle}
                iconStyling="glyphicon glyphicon-zoom-in"
                liClass={"out-on-mobile " + zooming}
              />
              <MenuIcon
                overlay={popover13}
                textPlacement="bottom"
                actionOnClick={this.props.blockingRectangle}
                iconStyling="glyphicon glyphicon-resize-full"
                liClass={"out-on-mobile " + blocking}
              />
            </span>
          }
          <MenuIcon
            overlay={popover1}
            textPlacement="bottom"
            actionOnClick={this.toggleFullScreen}
            iconStyling="glyphicon glyphicon-fullscreen"
            liClass="out-on-mobile"
          />
          {[
            'gmina_siekierczyn',
            'gmina_strzegom',
            'gmina_swierzawa',
            'gmina_zarow',
            'jawor',
            'swiebodzice'
          ].includes(this.props.prefix)
          ? null
          : <span>
            <MenuIcon
              overlay={popover2}
              textPlacement="bottom"
              actionOnClick={this.props.onPrevClick}
              iconStyling="glyphicon glyphicon-chevron-left"
            />
            <MenuIcon
              overlay={popover3}
              textPlacement="bottom"
              actionOnClick={this.props.onNextClick}
              iconStyling="glyphicon glyphicon-chevron-right"
            />
            <MenuIcon
              overlay={popover4}
              textPlacement="bottom"
              actionOnClick={this.props.onMeasureToolsClick}
              iconStyling="iconmenu"
              liClass={MeasureTools}
              src={iconPomiar}
            />
            <MenuIcon
              overlay={popover5}
              textPlacement="bottom"
              actionOnClick={this.props.onPrintClick}
              iconStyling="glyphicon glyphicon-print"
              liClass="out-on-mobile"
            />
            {/* <MenuIcon
              overlay={popover15}
              textPlacement="bottom"
              actionOnClick={this.props.onPDFClick}
              iconStyling="glyphicon glyphicon-picture"
              liClass="out-on-mobile"
            /> */}
            <MenuIcon
              overlay={popover6}
              textPlacement="bottom"
              actionOnClick={this.props.onSpeakClick}
              iconStyling="glyphicon glyphicon-volume-down speak-icon"
              liClass={TextToSpeech}
            />
            <MenuIcon
              overlay={popover11}
              textPlacement="bottom"
              actionOnClick={this.props.onLangSwitchIconClick}
              iconStyling="glyphicon glyphicon glyphicon-font"
              liClass={TextToSpeech}
            />
            <MenuIcon
              overlay={popover7}
              textPlacement="bottom"
              actionOnClick={this.props.onSpatialAnalysisClick}
              iconStyling="iconmenu"
              liClass={SpatialAnalysis}
              src={iconKlucz}
            /></span>
            }
            <MenuIcon
              overlay={popover9}
              textPlacement="bottom"
              actionOnClick={this.props.onUserIconClick}
              iconStyling="glyphicon glyphicon-user user-icon"
              liClass={user_login}
            />
            <MenuIcon
              overlay={popover10}
              textPlacement="bottom"
              actionOnClick={this.props.onInfoClick}
              iconStyling="glyphicon glyphicon-info-sign info-icon"
              liClass={info}
            />
            {this.props.prefix == 'krosno' ? 
            <MenuIcon
              overlay={popover14}
              textPlacement="bottom"
              actionOnClick={this.props.onSearchInvest}
              iconStyling="glyphicon glyphicon-search"
              liClass={info}
            /> : null}
        </ul>
      </div>
    );
  }
}

MapNav.contextTypes = {
  store: PropTypes.shape({
    subscribe: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
  }).isRequired,
};

const mapState = (state) => ({
  intl: state.intl
});

const mapDispatch = {};


export default withStyles(s)(connect(mapState, mapDispatch)(MapNav));



// WEBPACK FOOTER //
// src/components/MapNav/MapNav.js